import ReactGA from 'react-ga4';

const enabled =
    process.env.REACT_APP_GA_ENABLED === 'true' &&
    !!process.env.REACT_APP_GA_MEASUREMENT_ID;

export const initAnalytics = () => {
    if (!enabled) return;

    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID!);
};

export const trackPageView = (path: string) => {
    if (!enabled) return;

    ReactGA.send({
        hitType: 'pageview',
        page: path,
    });
};

export const trackEvent = (
    category: string,
    action: string,
    label?: string,
) => {
    if (!enabled) return;

    ReactGA.event({
        category,
        action,
        label,
    });
};
